import { jsx, css } from '@emotion/react';
import { useState, useCallback } from 'react';

import { getRequiredSuffix } from '../../../helpers/form_libs';
import RichText from '../../OC/oc-rich-text';
import { Grouped } from '../../PageBuilder/interface/vessels/Grouping';
import Labels from '../Labels';

const errorAlert = css`
  color: #940420;
  font-size: 12px;
  font-weight: bold;
`;

const ErrorDisplay = ({ field, errorSchema }) =>
  errorSchema?.__errors?.length > 0 ? (
    <p aria-describedby={field} aria-errormessage css={errorAlert} role="alert">
      {errorSchema?.__errors.join(', ')}
    </p>
  ) : null;

const Field = ({
  id,
  field,
  name,
  required,
  theme,
  value,
  onChange,
  uiSchema,
  errorSchema,
  schema,
  optionalFocused,
  elementType,
}) => (
  <div css={Grouped.Theme.get(theme, 'Editor')} key={field}>
    <Labels css={Grouped.Theme.get(theme, 'Labels')}>
      <label htmlFor={id || field} css={Grouped.Theme.get(theme, 'Label')}>
        {name?.trim?.()}
        {getRequiredSuffix(optionalFocused, required, elementType)}
      </label>
    </Labels>
    <div css={Grouped.Theme.get(theme, 'Wrapper')}>
      <input
        id={id}
        className="form-control"
        type="text"
        onChange={onChange}
        name={field}
        value={value}
        required={required}
      />
      {uiSchema?.['ui:help'] && <RichText content={uiSchema?.['ui:help']} />}
      <ErrorDisplay field={field} errorSchema={errorSchema?.[field]} />
    </div>
  </div>
);

const Title = ({
  formData = {},
  id,
  onChange: onChangeProp,
  schema,
  uiSchema,
  errorSchema,
  formContext,
  idSchema = {},
}) => {
  const theme = Grouped.Theme.Standard;
  const optionalFocused = formContext?.optionalFocused;

  const onChange = useCallback(value => onChangeProp(value, errorSchema, id), [JSON.stringify(errorSchema || {}), id]);

  return (
    <div css={Grouped.Theme.get(theme, ['Container', 'Horizontal'])}>
      <Field
        schema={schema}
        errorSchema={errorSchema}
        uiSchema={uiSchema?.first}
        field="first"
        id={`${idSchema?.$id}_first`}
        theme={theme}
        required={(schema.required || []).includes('first')}
        name={schema.properties.first.title}
        value={formData.first}
        onChange={e => onChange({ ...formData, first: e.target.value })}
        optionalFocused={optionalFocused}
        elementType={schema.properties.first.type}
      />

      <Field
        schema={schema}
        errorSchema={errorSchema}
        uiSchema={uiSchema?.last}
        field="last"
        id={`${idSchema?.$id}_last`}
        theme={theme}
        required={(schema.required || []).includes('last')}
        name={schema.properties.last.title}
        value={formData.last}
        onChange={e => onChange({ ...formData, last: e.target.value })}
        optionalFocused={optionalFocused}
        elementType={schema.properties.last.type}
      />
    </div>
  );
};

export default Title;
